export default (superclass) => class extends superclass {
    fetch(options = {}) {
        options.data = Backbone.$.param({
            filter: JSON.stringify(options.filter || {})
        });

        return super.fetch(options);
    }
};




// WEBPACK FOOTER //
// ./app/new-collections/mixins/loopback-fetch.js